import * as React from 'react';
import i18n from 'i18next';
import {
    headerTunables,
    opacityTunables,
    imagePostTunables,
    textPostTunables,
    userGroupTunables,
    engagementTunables,
    textEntityTunables,
    imageAdjustmentTunables,
    reviewPostTunables,
    handleExtras,
    adsTunables,
    smartSizeTunables,
    onChangeComposition,
    postTitleTunables,
    profanityTunables,
} from 'components/Sidebar/RenderTunables/SharedTunables';
import { CollapseProps, TunablesCollapse } from 'components/Sidebar/RenderTunables/RenderTunables';
import { postCompositionConfigCinematic } from 'components/Panel/PanelEditorSidebar/PanelDesign/PanelDesignOptions';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { Theme } from 'models/Theme/Theme';
import ActionSegmentedGroup from 'components/_UI/Forms/Actions/ActionSegmentedGroup';

const cinematicCompositions = [
    { value: 'a', label: i18n.t('Default'), icon: 'cinematic_a' },
    { value: 'b', label: i18n.t('Alternate'), icon: 'cinematic_b' },
    { value: 'c', label: i18n.t('Special'), icon: 'cinematic_c' },
];

const CinematicTunables = (widget: Widget, mergedTheme: Theme): TunablesCollapse[] => [
    {
        props: {
            label: i18n.t('Cinematic'),
            startOpen: true,
        } as CollapseProps,
        children: [...headerTunables(widget), opacityTunables(widget), smartSizeTunables(widget)],
    },
    {
        props: {
            label: i18n.t('Post Composition'),
            startOpen: true,
        } as CollapseProps,
        children: [
            <ActionSegmentedGroup
                key='widget.options.postCompositionType'
                label={i18n.t('Composition')}
                option={widget.options}
                value='postCompositionType'
                options={cinematicCompositions}
                handleSideEffects={selection =>
                    onChangeComposition(widget, selection, postCompositionConfigCinematic)
                }
            />,
        ],
    },
    postTitleTunables(widget, mergedTheme),
    textPostTunables(widget, mergedTheme),
    imagePostTunables(widget, mergedTheme),
    reviewPostTunables(widget, mergedTheme),
    imageAdjustmentTunables(widget),
    userGroupTunables(widget),
    engagementTunables(widget),
    adsTunables(widget),
    textEntityTunables(widget),
    profanityTunables(widget),
];

export default CinematicTunables;
